module.exports = __webpack_public_path__ + "img/1.19808097.jpg";